import React from 'react'
import ClientLibraryHref from './ClientLibraryHref'

class ClientLibraryModuleView extends React.Component {
  buildView(job) {
    let href = ClientLibraryHref({job: job, roleType: this.props.roleType})

    return (
      <a key={job.id} className="card col-2 p-0 mx-2" href={href}>
        <div className="view overlay hm-white-slight asset-preview-xsmall cursor-pointer">
          <div className="text-center default-placeholder w-100 h-100 js-image-holder" data-src={job.preview_path} >
            <p className="m-0 js-no-preview-text">No preview</p>
          </div>
        </div>
        <div className="card-block p-2">
          <p className="grey-text text-darken-3 mb-0">
            {job.publish_on}
          </p>
          <small className="grey-text text-darken-3">
            {job.size}
          </small>
        </div>
      </a>
    )
  }

  groupJobs(jobs) {
    let arr = []
    while (jobs.length > 0){
      arr.push(jobs.splice(0, 5));
    }
    return arr
  }

  componentDidMount() {
    $('.js-image-holder').each((i, ele) => {
      let img = new Image()
      $(ele).css('background-image', `url(${$(ele).attr('data-src')})`);
      img.src = $(ele).attr('data-src')
      img.onload = () => {
        $(ele).data('src', "")
        $(ele).addClass('bg-photo')
        $(ele).removeClass('text-center default-placeholder')
        $(ele).children('.js-no-preview-text').remove()
      };
    });
  }

  render() {
    let groupedJobs = this.groupJobs(this.props.data.slice(0)) // clone the array
    const items = groupedJobs.map((group, i) => {
      if (group.constructor == Array) {
        return (
          <div key={i} className="d-flex flex-row w-100 mb-5">
           { group.map((job) => {
              return (
                this.buildView(job)
              )
            }) }
          </div>
        )
      } else {
        return (
          <div key={i} className="d-flex flex-row w-100">
            {this.buildView(group)}
          </div>
        )
      }
    })
    return (
      <div>
        {items}
      </div>
    )
  }
}

export default ClientLibraryModuleView
